'use strict';
var PageLevelAlertMessagingController = /** @class */ (function () {
    /*@ngInject*/
    function PageLevelAlertMessagingController($scope) {
        this.$scope = $scope;
        $scope.showAlert = true;
        $scope.closeAlertMessage = function () {
            $scope.showAlert = false;
        };
        // if (Array.isArray(this.message)){
        //   this.messageDataType = 'array';
        // } else {
        //   this.messageDataType = 'string';
        // }
    }
    PageLevelAlertMessagingController.prototype.$onChanges = function (changes) {
        if (changes.message) {
            if (Array.isArray(this.message)) {
                this.messageDataType = 'array';
            }
            else {
                this.messageDataType = 'string';
            }
        }
    };
    return PageLevelAlertMessagingController;
}());
export default PageLevelAlertMessagingController;
//# sourceMappingURL=site-alert-messaging.controller.js.map